function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 3c0-1.656-1.159-3-3-3s-3 1.344-3 3H8v1H5a1 1 0 00-1 1v24a1 1 0 001 1h20a1 1 0 001-1V5a1 1 0 00-1-1h-3V3h-4zm-2 0a1 1 0 11-2 0 1 1 0 012 0zM6 29a1 1 0 01-1-1V7a1 1 0 011-1h18a1 1 0 011 1v21a1 1 0 01-1 1H6zm11.423-15.782c0-.98-.242-1.903-.66-2.718A5.95 5.95 0 0120 15.795a5.955 5.955 0 01-5.956 5.955 5.95 5.95 0 01-5.294-3.238c.815.42 1.737.66 2.717.66a5.955 5.955 0 005.956-5.954z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "4",
  y: "0",
  width: "22",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 3c0-1.656-1.159-3-3-3s-3 1.344-3 3H8v1H5a1 1 0 00-1 1v24a1 1 0 001 1h20a1 1 0 001-1V5a1 1 0 00-1-1h-3V3h-4zm-2 0a1 1 0 11-2 0 1 1 0 012 0zM6 29a1 1 0 01-1-1V7a1 1 0 011-1h18a1 1 0 011 1v21a1 1 0 01-1 1H6zm11.423-15.782c0-.98-.242-1.903-.66-2.718A5.95 5.95 0 0120 15.795a5.955 5.955 0 01-5.956 5.955 5.95 5.95 0 01-5.294-3.238c.815.42 1.737.66 2.717.66a5.955 5.955 0 005.956-5.954z",
  fill: "currentColor"
}))));